export default __webpack_public_path__ + "media/enterpreneurship.7cf09212.png";